"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeStyles = exports.mapStyles = exports.switchStyles = exports.hasOwnProperty = void 0;
/**
 * Checks whether a given prop exists and truthy on the props object.
 * @param obj Props object
 * @param prop Prop to check
 */
var hasOwnProperty = function (obj, prop) {
    if (obj === void 0) { obj = {}; }
    return Object.prototype.hasOwnProperty.call(obj, prop);
};
exports.hasOwnProperty = hasOwnProperty;
/**
 * Applies a given style if a prop exists on a props object.
 * @param props Props object
 * @param prop Prop that controls the style
 * @param styles Styles to apply as a string literal or using css helper from
 * `styled-components`(https://styled-components.com/docs/api#css)
 */
var switchStyles = function (props, prop, styles) {
    if ((0, exports.hasOwnProperty)(props, prop) && props[prop]) {
        return styles;
    }
    return '';
};
exports.switchStyles = switchStyles;
/**
 * Maps a style in a collection of styles to a matched prop in props.
 * @param props Props object
 * @param prop Prop that controls the style
 * @param map A map of styles as string literals or created with css helper from
 * `styled-components`(https://styled-components.com/docs/api#css). Keys on the
 * object are used to apply the styles by passing them into the prop.
 */
var mapStyles = function (props, prop, map) {
    var _a;
    if ((0, exports.hasOwnProperty)(props, prop) && props[prop]) {
        return (_a = map[props[prop]]) !== null && _a !== void 0 ? _a : '';
    }
    return '';
};
exports.mapStyles = mapStyles;
/**
 * Generates a style from a matched prop in props.
 * @param props Props object
 * @param prop Prop that controls the style
 * @param makeStyles A function that returns a style as string literals or
 * created with css helper from `styled-components`
 * (https://styled-components.com/docs/api#css). This function will be passed
 * the value from the prop, in case if it is needed to construct the style. As a
 * second argument, the function will receive the theme, if exists.
 */
var makeStyles = function (props, prop, makeStyles) {
    var _a;
    if ((0, exports.hasOwnProperty)(props, prop) && props[prop]) {
        return (_a = makeStyles(props[prop], props.theme)) !== null && _a !== void 0 ? _a : '';
    }
    return '';
};
exports.makeStyles = makeStyles;
//# sourceMappingURL=index.js.map